import * as Immutable from 'immutable';
import ProductOptionTypeStore from '../../AppData/_stores/ProductOptionTypeStore';
import PreviewStore from '../../AppData/_stores/PreviewStore';
import semver from 'semver';
import { PricePayload } from '../../UIData/_stores/PriceStore';

export type UserProductDesignStatus = 'available'|'deleted'|'permadeleted'

export type UserProductDesignPayload = {
	id: number
	id_product_design: number
	id_product: number
	id_view_product: number | null
	id_user: number
	id_product_variant: number|null
	status: UserProductDesignStatus
	name: string
	thumbnail: string
	preview: string
	date_created: string
	labVersion: string
	designData: any
	availableOptionTypes: {
		id: number,
		type: 'enum'|'bool',
		slug: string,
		name: string,
		theorder: number,
		visible: boolean,
		options: {
			id: number,
			id_product_variant: number,
			id_product_option_type: number,
			listDependencies: number[]
			slug: string,
			name: string,
			theorder: number,
			price_retail: PricePayload
			price_wholesale: PricePayload
			price_dropship: PricePayload
		}[],
	}[],
	defaultOptions: {
		id: number,
		id_product_option_type: number,
	}[],
	previews: {
		id: number,
		url: string,
	},
	textures: {
		id: number,
		slug: string,
		url: string,
	}[],
	details: {
		slug: string,
		valueSlug: string,
	}[],
	linkedStores: string[],
}

interface IUserProductDesignStore {
	id: number
	id_product_design: number
	id_product: number
	id_view_product: number | null
	id_product_variant: number | null
	variant: string
	name: string
	thumbnail: string
	preview: string
	labVersion: string
	availableOptionTypes: Immutable.Map<string, ProductOptionTypeStore>
	defaultOptions: Immutable.Map<number, number>
	previews: Immutable.Map<number, PreviewStore>
	textures: Immutable.Map<number, PreviewStore>
	details: Immutable.Map<string, string>
	linkedStores: Immutable.OrderedSet<string>
	designData: Record<string, any>
}

const defaultUserProductDesignStore = Immutable.Record<IUserProductDesignStore>({
	id: 0,
	id_product_design: 0,
	id_product: 0,
	id_view_product: null,
	id_product_variant: null,
	variant: '',
	name: '',
	thumbnail: '',
	preview: '',
	labVersion: '',
	availableOptionTypes: Immutable.Map<string, ProductOptionTypeStore>(),
	defaultOptions: Immutable.Map<number, number>(),
	previews: Immutable.Map<number, PreviewStore>(),
	textures: Immutable.Map<number, PreviewStore>(),
	details: Immutable.Map<string, string>(),
	linkedStores: Immutable.OrderedSet<string>(),
	designData: {},
});

export class UserProductDesignStore extends defaultUserProductDesignStore implements IUserProductDesignStore {
	public isEditable():boolean {
		const labVersion = this.get('labVersion')

		return labVersion !== '' && semver.gte(labVersion, '4.0.0');
	}
}
